<app-menu/>

<div class="column shrink mobile-version">
  <a routerLink="/account" class="alert">Продовжити покупки</a>
</div>

<div class="page-container">
  <div class="orders-history" *ngIf="activeOrganization && activeOrganization.type !== 'fiz'">
    <div class="row">
      <div class="column shrink">
        <h2>Взаєморозрахунки</h2>
      </div>
    </div>

    <div class="row">
      <div class="column sum-flex"></div>
      <div class="column shrink sum-duty">
        <table class="itog">
          <tbody>
          <tr>
            <td>Поточний {{ buBalance > 0 ? 'борг' : 'баланс' }}:</td>
            <td [class.credit]="buBalance > 0" [class.debit]="buBalance <= 0">
              {{ (buBalance > 0 ? buBalance : buBalance * -1) | number:'1.2-2' }} ₴
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row orders" *ngIf="buOrders.length > 0">
      <div class="column scrollable">
        <table class="data">
          <thead>
          <tr>
            <th class="date-style">Дата</th>
            <th>Тип</th>
            <th class="return-head-order">№ Замовлення</th>
            <th class="comment-style">Коментар</th>
            <th>Сума</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let buOrder of buOrders" [class.assistant-highlight]="buOrder.doc_type === 'sale' && highlight.has(buOrder.order_id)">
            <td class="date-styles">{{ buOrder.datetime }}</td>
            <td>
              <ng-container [ngSwitch]="buOrder.doc_type">
                <span *ngSwitchCase="'sale'">Продаж</span>
                <span *ngSwitchCase="'return'">Повернення</span>
                <span *ngSwitchCase="'payment'">Оплата</span>
              </ng-container>
            </td>
            <td>{{ buOrder.order_id }}</td>
            <td>{{ buOrder.comment }}</td>
            <td class="abovezero-sum" [class.debit]="buOrder.summa_total < 0">
              {{ buOrder.summa_total > 0 ? '+' : '' }}{{ buOrder.summa_total | number:'1.2-2' }} ₴
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row" *ngIf="buOrders.length === 0">
      <div class="column">
        <p>Операції відсутні</p>
      </div>
    </div>
  </div>

  <div class="orders-history" [class.start-print]="startPrint" *ngIf="!activeOrganization || activeOrganization.type === 'fiz'">
    <div class="row">
      <div class="column shrink desktop-version">
        <h2>Замовлення по {{ pageType === 1 ? "передплатам" : "накладеним платежах" }}</h2>
      </div>
    </div>

    <div class="row" *ngIf="returns">
      <div class="column column-return">
        <div class="row">
          <div class="column shrink">
            <h2>Заявки на повернення</h2>
          </div>
        </div>
        <div class="inner">
          <div class="column">
            <table class="data">
              <thead>
              <tr>
                <th class="return-delete-btn-style desktop-version"></th>
                <th class="date-style">Дата</th>
                <th class="return-head-order">Замовлення</th>
                <th class="comment-style">Коментар</th>
                <th class="return-head-sum">Сума</th>
                <th class="return-delete-btn-style mobile-version"></th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let ret of returns">
                <td *ngIf="!ret.processed" class="return-delete-btn desktop-version">
                  <a (click)="deletePreReturn(ret.id)" class="delete_prereturn"></a>
                </td>
                <td class="return-data" [attr.colspan]="ret.processed ? 2 : 1">
                  {{ ret.datetime }}
                  <small *ngIf="ret.processed" class="button-return-style">
                    Вашу заявку на повернення прийнято <br> і буде підтверджено найближчим часом.
                  </small>
                </td>
                <td class="return-order" (click)="showModalReturns(ret)">
                  <a>Повернення до замовлення №{{ ret.order_id }}</a>
                </td>
                <td>{{ ret.comment }}</td>
                <td class="return-sum">
                <span class="return-sum_uan">
                  <strong>{{ ret.sum_fixed_uan }} UAH</strong>
                </span>
                  <span class="amount-style desktop-version">
                    {{ ret.sum_fixed }} EUR
                    ({{ ret.rate }})
                </span>
                  <span class="amount-style mobile-version">
                      ({{ ret.sum_fixed }} EUR)
                </span>
                </td>
                <td *ngIf="!ret.processed" class="return-delete-btn mobile-version">
                  <a (click)="deletePreReturn(ret.id)" class="delete_prereturn"></a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="mobile-version">
      <div class="column">
        <div class="column shrink orders-text">
          <h2>Замовлення по {{ pageType === 1 ? "передплатам" : "накладеним платежах" }}</h2>
        </div>
        <div class="column shrink" *ngIf="!activeOrganization || activeOrganization.type === 'fiz'">
          <a [routerLink]="pageType === 1 ? '/orders_history_nalojki' : '/orders_history_new'" class="button order">
            Перейти до замовлень по {{ pageType === 1 ? "накладеним платежах" : "передоплатам" }}
          </a>
        </div>
        <div *ngIf="pageType === 2" class="column shrink">
          <a *ngIf="sum && sum.summa != 0" class="button"
             [class.balans]="sum.summa < 0"
             [class.debt]="sum.summa > 0"
             (click)="transferBalance()"
          >
            Перенести {{ sum.summa < 0 ? "баланс" : "борг" }} на предоплату
          </a>
        </div>

        <div *ngIf="pageType === 2" class="column shrink">
          <a class="button" (click)="showInfo()">Інф</a>
        </div>

        <div class="column shrink">
          <a (click)="downloadFile()" class="button">
            Завантажити акт звірку
          </a>
        </div>

        <div class="search-string">
          <div class="column">
            <input
              type="text"
              placeholder="Пошук: артикул. № замов. адр. доставки. найменуванню"
              (input)="searchData()"
              [(ngModel)]="search"
            >
          </div>

          <div class="column shrink">
            <button type="submit" *ngIf="search === ''">Знайти</button>
            <button type="button" *ngIf="search !== ''" (click)="crossClears()">Видалити</button>
          </div>
        </div>

        <div class="column sort-by-date">
          <label>Сортувати за датою:</label>
          <div class="input-style">
            <input class="input-date" type="date" (blur)="searchData()" [(ngModel)]="date_from">
            -
            <input class="input-date" type="date" (blur)="searchData()" [(ngModel)]="date_to">
          </div>
        </div>

        <div class="column sort-by-date" *ngIf="pageType === 1">
          <label>Сортування по доставці:</label>
          <br>
          <select (change)="searchData()" [(ngModel)]="delivery">
            <option value="">Вибрати склад, доставку</option>
            <option *ngFor="let del of deliveryInfo" value="{{del.id}}">{{ del.name }}</option>
          </select>
        </div>
        <div class="column">
          <span class="button" (click)="clearFilters()">
           Скидання фільтрів
          </span>
        </div>
      </div>

      <div class="column shrink sum-duty">
        <table *ngIf="sum && sum.summa" class="itog">
          <tbody>
          <tr>
            <td class="balance-text-style">Поточний {{ sum.summa < 0 ? "баланс" : "борг" }}:</td>
            <td *ngIf="pageType === 1" [class.debit]="sum.summa < 0" [class.credit]="sum.summa >= 0">
              {{ sumFormatted }} ₴
              <span>
                ({{ sum.summa < 0 ? (sum.summa).toFixed(2) * -1 : (sum.summa).toFixed(2) }} €)
              </span>
            </td>
            <td *ngIf="pageType === 2" [class.debit]="sum.summa < 0" [class.credit]="sum.summa >= 0">
              {{ sum.summa < 0 ? (sum.summa).toFixed(2) * -1 : (sum.summa).toFixed(2) }} ₴
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row items-center search-row desktop-version">
      <div class="column">
        <div class="search-string">
          <input
            type="text"
            class="input-search"
            placeholder="Пошук по: артикул., № замов., адр. доставки., найменуванню"
            (input)="searchData()"
            [(ngModel)]="search"
          >
          <label *ngIf="search === ''" class="search-icon"></label>
          <button type="button" *ngIf="search !== ''" class="cross-clears" (click)="crossClears()"></button>
        </div>
      </div>
      <div class="column shrink sort-by-date">
        <input class="input-date" type="date" (blur)="searchData()" [(ngModel)]="date_from">
        -
        <input class="input-date" type="date" (blur)="searchData()" [(ngModel)]="date_to">
      </div>
      <div class="column shrink sort-by-date" *ngIf="pageType === 1">
        <select (change)="searchData()" [(ngModel)]="delivery">
          <option value="">Вибір складу доставки</option>
          <option *ngFor="let del of deliveryInfo" value="{{del.id}}">{{ del.name }}</option>
        </select>
      </div>
      <div class="column shrink">
        <span class="alert" (click)="clearFilters()">❌</span>
      </div>
      <div class="column shrink">
        <a (click)="downloadFile()" class="button button-download-list">
          Завантажити звірку
        </a>
      </div>
    </div>

    <div class="row links desktop-version">
      <div class="column shrink" *ngIf="!activeOrganization || activeOrganization.type === 'fiz'">
        <a [routerLink]="pageType === 1 ? '/orders_history_nalojki' : '/orders_history_new'" class="button order">
          Перейти до замовлень по {{ pageType === 1 ? "накладеним платежах" : "передоплатам" }}
        </a>
      </div>
      <div *ngIf="pageType === 2" class="column shrink p0">
        <a *ngIf="sum && sum.summa != 0" class="button"
           [class.balans]="sum.summa < 0"
           [class.debt]="sum.summa > 0"
           (click)="transferBalance()"
        >
          Перенести {{ sum.summa < 0 ? "баланс" : "борг" }} на предоплату
        </a>
      </div>
      <div *ngIf="pageType === 2" class="column shrink p0">
        <a class="button" (click)="showInfo()">Інф</a>
      </div>

      <div class="column shrink sum-flex"></div>

      <div class="column shrink sum-duty">
        <table *ngIf="sum && sum.summa" class="itog">
          <tbody>
          <tr>
            <td>Поточний {{ sum.summa < 0 ? "баланс" : "борг" }}:</td>
            <td *ngIf="pageType === 1" [class.debit]="sum.summa < 0" [class.credit]="sum.summa >= 0">
              {{ sumFormatted }} ₴
              <span>
                ({{ sum.summa < 0 ? (sum.summa).toFixed(2) * -1 : (sum.summa).toFixed(2) }} €)
              </span>
            </td>
            <td *ngIf="pageType === 2" [class.debit]="sum.summa < 0" [class.credit]="sum.summa >= 0">
              {{ sum.summa < 0 ? (sum.summa).toFixed(2) * -1 : (sum.summa).toFixed(2) }} ₴
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div *ngIf="orders" class="row orders">
      <div class="column scrollable">
        <table class="data">
          <thead>
          <tr>
            <th class="date-style">Дата</th>
            <th class="return-head-order">Замовлення</th>
            <th>Коментар</th>
            <th style="width: 170px">Тип доставки</th>
            <th style="width: 178px">Статус замовлення</th>
            <th>№ декларації</th>
            <th>Сума</th>
          </tr>
          </thead>
          <tbody>

          <ng-container *ngFor="let order of orders">
            <tr [class.lightgrey_row]="order.is_return"
                [class.assistant-highlight]="!order.is_oplata && !order.is_return && !order.is_transfer && highlight.has(order.order_id)">
              <td class="date-styles">
                {{ order.datetime }}
              </td>

              <td *ngIf="order.is_oplata" class="pay">
                <a class="order-pay">Оплата покупця</a>
                <div *ngIf="order.calc_comment2" class="prebulb">
                  <label>!</label>
                  <div class='bulb'>
                    Замовлення: {{ order.calc_comment2 }}
                    <div class='bulbarrow'></div>
                  </div>
                </div>
              </td>

              <td *ngIf="!order.is_oplata && order.is_return" class="order transfer" (click)="showOrder(order)">
                <a>
                  <span>Повернення</span> до замовлення №{{ order.order_id }}
                </a>
              </td>

              <td *ngIf="!order.is_oplata && !order.is_return && order.is_transfer" class="order">
                Перенос {{ pageType === 1 ? "с наложек" : "на предоплату" }}
              </td>

              <td *ngIf="!order.is_oplata && !order.is_return && !order.is_transfer" class="order transfer"
                  (click)="showOrder(order)">
                <a *ngIf="order.isset_rn_doc_pdf" class="rn_doc_pdf"
                   (click)="downloadRnPdf($event, order.order_id)">&nbsp;
                </a>
                <a>Замовлення № {{ order.order_id }}</a>
                <br>
                <ng-container *ngIf="pageType === 1">
                  <small *ngIf="order.summa > 0" class="abovezero desktop-version">
                    Сума: {{ order.summa_converted_format }} грн.
                    ({{ order.rate2 }})
                  </small>
                </ng-container>
                <small *ngIf="order.summa_nalojki > 0" class="abovezero-nalojki">
                  Сума наложкі: {{ order.summa_nalojki < 0 ? order.summa_nalojki * -1 : order.summa_nalojki }} грн.
                </small>
              </td>

              <td class="comments">
                <ng-container *ngIf="!order.is_return">
                  {{ order.comment }}
                </ng-container>
              </td>

              <td>
                <ng-container *ngIf="!order.is_return">
                  {{ order.courier }}
                  <span *ngIf="order.places">
                  <br>
                  Місць: {{ order.places }}
                </span>
                  <small *ngIf="order.datedelivery" class="abovezero-delivery">
                    <ng-container
                      *ngIf="order.delivery_id == 2 || order.delivery_id == 7 ; else typeDelivery"
                    >
                      Заберу:
                    </ng-container>
                    <ng-template #typeDelivery>
                      <ng-container *ngIf="order.delivery_id == 1 || order.delivery_id > 30; else typeSend">
                        Доставка:
                      </ng-container>
                    </ng-template>
                    <ng-template #typeSend>
                      Відправка:
                    </ng-template>
                    {{ order.datedelivery }}
                  </small>
                </ng-container>
              </td>

              <td>
                <ng-container *ngIf="!order.is_return">
                  <a *ngIf="order.all_returned; else shippedStatus"
                     class="status"
                  >
                    <span>Повернення</span>
                  </a>
                  <ng-template #shippedStatus>
                    <a *ngIf="order.status_id == 4 || order.declaraciya; else newStatus"
                       class="status"
                       (click)="showTrackStatus(order)"
                    >
                      <span>Відвантажено</span>
                    </a>
                  </ng-template>
                  <ng-template #newStatus>
                    <a *ngIf="order.status_id == 1; else onTheWay"
                       class="status beige"
                       (click)="showTrackStatus(order)"
                    >
                      <span>Новий</span>
                    </a>
                  </ng-template>
                  <ng-template #onTheWay>
                    <a *ngIf="order.status_id == 12; else doneStatus"
                       class="status brown"
                       (click)="showTrackStatus(order)"
                    >
                      <span>В дорозі</span>
                    </a>
                  </ng-template>
                  <ng-template #doneStatus>
                    <a *ngIf="order.places; else collectedStatus"
                       class="status red"
                       (click)="showTrackStatus(order)"
                    >
                      <span>Готово до відправки</span>
                    </a>
                  </ng-template>
                  <ng-template #collectedStatus>
                    <a class="status red"
                       *ngIf="order.status_id == 5 || order.status_id == 6"
                       (click)="showTrackStatus(order)"
                    >
                      <span>Зібраний та запакований</span>
                    </a>
                  </ng-template>
                </ng-container>
              </td>

              <td [class.ttn-declaraciya]="pageType === 1 &&
            order.delivery_id == 8 &&
            !order.trakstatus &&
            !order.isset_order_returns &&
            !order.all_returned &&
            order.declaraciya === null"
                  [class.ttn-declaraciya-found]="order.added_ttn"
              >
                <ng-container *ngIf="!order.is_return">
                  <div class="contenteditable"
                       appContenteditable
                       [onlyNumber]="true"
                       [(ngModel)]="order.declaraciya_text"
                       (blur)="setTtn(order)"
                       *ngIf="pageType === 1 && order.delivery_id == 8 && !order.trakstatus &&
                        !order.isset_order_returns && !order.all_returned; else shippedStatus"
                  >
                  </div>
                  <ng-template #shippedStatus>
                    {{ order.declaraciya }}
                  </ng-template>
                </ng-container>
              </td>

              <td class="abovezero-sum">
                <span *ngIf="pageType === 1" [class.debit]="order.summa < 0">
                  {{ order.summa_converted_format }} ₴
                </span>
                <span *ngIf="pageType === 2" [class.debit]="order.summa < 0">
                  {{ (order.summa < 0 ? order.summa * -1 : order.summa).toFixed(2) }} ₴
                </span>
                <ng-container *ngIf="order.rate > 0; else rateLess">
                  <ng-container *ngIf="pageType === 1">
                    <span style="color: #25B733;">({{ order.rate }})</span>
                    <br>
                    <span style="color: #ffb101;">
                      ({{ (order.summa < 0 ? order.summa * -1 : order.summa).toFixed(2) }} €)
                    </span>
                  </ng-container>
                </ng-container>
                <ng-template #rateLess>
                  <span *ngIf="pageType === 1" class="all-sum-style">
                    ({{ (order.summa < 0 ? order.summa * -1 : order.summa).toFixed(2) }} €)
                  </span>
                </ng-template>
              </td>
            </tr>

            <tr class="content-order" *ngIf="order.show_order && order.ordered_products">
              <td colspan="7">
                <div class="indentation">
                  <ng-container *ngFor="let prro of order.prro">
                    <ng-container *ngIf="prro.receiptId; else prroId">
                      <p>
                        <a href='https://check.checkbox.ua/{{prro.receiptId}}' target="_blank">Фіскальний чек</a>
                      </p>
                    </ng-container>
                    <ng-template #prroId>
                      <p *ngIf="prro.id">
                        <a href='https://check.checkbox.ua/{{prro.id}}' target="_blank">Фіскальний чек</a>
                      </p>
                    </ng-template>
                  </ng-container>
                  <p class="fixed-position" *ngIf="order.users_addresses.courier_num">
                    Відділення: {{ order.users_addresses.courier_num }}</p>
                  <p class="fixed-position" *ngIf="order.users_addresses.city">
                    Місто: {{ order.users_addresses.city }}</p>
                  <p class="fixed-position" *ngIf="order.users_addresses.fio">
                    Одержувач: {{ order.users_addresses.fio }}</p>
                  <p class="fixed-position" *ngIf="order.users_addresses.phone">Телефон
                    одержувача {{ order.users_addresses.phone }}</p>
                  <p class="fixed-position" *ngIf="order.datedelivery">Дата відправки: {{ order.datedelivery }}</p>
                  <p class="fixed-position" *ngIf="order.deliveryHours">Час відправки: {{ order.deliveryHours }}</p>
                  <p class="fixed-position">Кількість літрів: {{ order.liters }}</p>
                  <p class="fixed-position" *ngIf="order.comment">Коментар: {{ order.comment }}</p>
                  <br>
                  <table class='order-data'>
                    <thead>
                    <tr>
                      <th class="fixed-position">Найменування</th>
                      <th>Склад</th>
                      <th>Фасовка</th>
                      <th>Артикул</th>
                      <th>Ціна</th>
                      <th>Кіл-ть</th>
                      <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <ng-container *ngFor="let orderProduct of order.ordered_products">
                      <tr *ngIf="!orderProduct.returned">
                        <td class="fixed-position-background">{{ orderProduct.name }}</td>
                        <td>
                          <ng-container *ngIf="orderProduct.war !== null">
                            <ng-container *ngIf="orderProduct.war === 1">Центр</ng-container>
                            <ng-container *ngIf="orderProduct.war === 7">Брожка</ng-container>
                            <ng-container *ngIf="orderProduct.war !== 1 && orderProduct.war !== 7">Партнер
                            </ng-container>
                          </ng-container>
                        </td>
                        <td>{{ orderProduct.pack }}</td>
                        <td>{{ orderProduct.firstArticle }}
                          <div class="prebulb">
                            <label *ngIf="orderProduct.lastArticles">
                              {{ orderProduct.resultLastArticleGood.length }}
                            </label>
                            <div class="bulb" *ngIf="orderProduct.lastArticles">
                              <div class="bulbarrow"></div>
                              <span>
                                    <div *ngFor="let article of orderProduct.lastArticles">
                                     {{ article }}
                                    </div>
                                   </span>
                            </div>
                          </div>
                        </td>
                        <td *ngIf="pageType === 1">{{ orderProduct.price }} €</td>
                        <td *ngIf="pageType === 2">{{ orderProduct.price }} ₴</td>
                        <td>{{ orderProduct.count }}</td>
                        <td>
                          <a class="button butt_to_basket"
                             *ngIf="orderProduct.pack_id !== 772 &&
                             orderProduct.pack_id !== 774 &&
                             orderProduct.pack_id !== 775 &&
                             orderProduct.pack_id !== 776 &&
                             orderProduct.pack_id !== 777 &&
                             orderProduct.pack_id !== 888 &&
                             orderProduct.pack_id !== 999"
                             [routerLink]="['/account']"
                             [queryParams]="{good_id: orderProduct.pack_id}"
                          >
                            Замовити
                          </a>
                        </td>
                      </tr>
                    </ng-container>
                    </tbody>
                  </table>

                  <div class="flex-container">
                    <div class="button-container">
                      <a class="button small"
                         [routerLink]="['/account']"
                         [queryParams]="{goods_ids: order.good_ids}">
                        Повторити замовлення
                      </a>
                      <button *ngIf="order.status_id === 1 && order.canChangeDeliveryDate"
                              class="button small change-date"
                              (click)="deliveryDateModalShow(order)">
                        Змінити дату відправки
                      </button>
                      <div class="button-container-mobile">
                        <a class="download-order-button-mobile" (click)="download(order.order_id)">
                          <i class="fa fa-arrow-circle-o-down" aria-hidden="true"></i>
                        </a>
                        <a class="print-order-button-mobile" (click)="userPrinterGetOrder(order)">
                          <i class="fa fa-print" aria-hidden="true"></i>
                        </a>
                      </div>
                    </div>
                    <div class="download-and-print-order-container">
                      <div class="column shrink">
                        <a class="button small download-order-button-desktop" (click)="download(order.order_id)">
                          Завантажити замовлення
                        </a>
                      </div>
                      <div class="column shrink">
                        <a class="button small print-order-button-desktop" (click)="userPrinterGetOrder(order)">
                          Роздрукувати замовлення
                        </a>
                      </div>
                    </div>
                  </div>

                  <ng-container *ngIf="order.returns">
                    <div *ngFor="let ret of order.returns">
                      <h3>Повернення від {{ ret.datetime }} <br> на замовлення
                        №{{ order.order_id }}
                      </h3>
                      <br>
                      <p class="fixed-position">
                        Сума повернення:
                        <b>{{ ret.summa_converted_format }} UAH</b>
                        <ng-container *ngIf="pageType === 1">
                          {{ ret.summa }}
                          EUR
                        </ng-container>
                        <br>
                        {{ ret.return_status_name }}
                        <ng-container *ngIf="ret.comment">
                          <br>Коментар: {{ ret.comment }}
                        </ng-container>
                      </p>
                      <br>
                      <table class="order-data">
                        <thead>
                        <tr>
                          <th class="fixed-position">Найменування</th>
                          <th>Склад</th>
                          <th>Фасовка</th>
                          <th>Артикул</th>
                          <th>Ціна</th>
                          <th>Кіл-ть</th>
                          <th>Сума</th>
                        </tr>
                        </thead>
                        <tbody>
                        <ng-container *ngFor="let orderProduct of order.ordered_products">
                          <tr
                            *ngIf="order.ordered_products && orderProduct.returned && orderProduct.return_id == ret.id ">
                            <td class="fixed-position-background">{{ orderProduct.name }}</td>
                            <td>
                              <ng-container *ngIf="orderProduct.war !== null">
                                <ng-container *ngIf="orderProduct.war === 1">Центр</ng-container>
                                <ng-container *ngIf="orderProduct.war === 7">Брожка</ng-container>
                                <ng-container *ngIf="orderProduct.war !== 1 && orderProduct.war !== 7">Партнер
                                </ng-container>
                              </ng-container>
                            </td>
                            <td>{{ orderProduct.pack }}</td>
                            <td>{{ orderProduct.firstArticle }}
                              <div class="prebulb">
                                <label *ngIf="orderProduct.lastArticles">
                                  {{ orderProduct.resultLastArticleGood.length }}
                                </label>
                                <div class="bulb" *ngIf="orderProduct.lastArticles">
                                  <div class="bulbarrow"></div>
                                  <span>
                                    <div *ngFor="let article of orderProduct.lastArticles">
                                     {{ article }}
                                    </div>
                                   </span>
                                </div>
                              </div>
                            </td>
                            <td *ngIf="pageType === 1">{{ orderProduct.price }} €</td>
                            <td *ngIf="pageType === 2">{{ orderProduct.price }} ₴</td>
                            <td>{{ orderProduct.count }}</td>
                            <td>{{ orderProduct.summa }}</td>
                          </tr>
                        </ng-container>
                        </tbody>
                      </table>
                    </div>
                    <div class='row'>
                      <div class='column'></div>
                      <div class='column shrink'>
                        <a class='button small' (click)="download(order.order_id)">
                          Завантажити повернення
                        </a>
                        <br>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </td>
            </tr>
            <tr *ngIf="order.show_order">
              <td class="border-right-hide"></td>
            </tr>
          </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="order-print" *ngIf="printOrder && orderPrint">
    <h3 class='text-center'>Замовлення №{{ orderPrint.order_id }}</h3>
    <br>
    <p>
      Дата Замовлення: {{ orderPrint.datetime }}
    </p>
    <p>
      Сума замовлення: {{ (orderPrint.summa < 0 ? orderPrint.summa * -1 : orderPrint.summa).toFixed(2) }}
      <ng-container *ngIf="pageType === 1">
        {{ orderPrint.currency_id == 3 ? "УЕ" : "UAH" }}
      </ng-container>
      <ng-container *ngIf="pageType === 2">
        {{ "UAH" }}
      </ng-container>
    </p>
    <p>
      Тип доставки: {{ orderPrint.courier }}
    </p>
    <p *ngIf="orderPrint.users_addresses.city">
      Місто: {{ orderPrint.users_addresses.city }}
    </p>
    <p *ngIf="orderPrint.users_addresses.fio">
      Одержувач: {{ orderPrint.users_addresses.fio }}
    </p>
    <p *ngIf="orderPrint.users_addresses.phone">
      Телефон одержувача {{ orderPrint.users_addresses.phone }}
    </p>
    <p *ngIf="orderPrint.comment">
      Коментар {{ orderPrint.comment }}
    </p>
    <br>

    <table class='order-data'>
      <thead>
      <tr>
        <th>Бренд</th>
        <th>Найменування</th>
        <th>Склад</th>
        <th>Фасовка</th>
        <th>Артикул</th>
        <th>Ціна</th>
        <th>Кіл-ть</th>
        <th>Сума</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let orderProduct of orderPrint.ordered_products">
        <ng-container *ngIf="!orderProduct.returned">
          <td>{{ orderProduct.brand }}</td>
          <td>{{ orderProduct.name }}</td>
          <td>
            <ng-container *ngIf="orderProduct.war !== null">
              <ng-container *ngIf="orderProduct.war === 1">Центр</ng-container>
              <ng-container *ngIf="orderProduct.war === 7">Брожка</ng-container>
              <ng-container *ngIf="orderProduct.war !== 1 && orderProduct.war !== 7">Партнер</ng-container>
            </ng-container>
          </td>
          <td>{{ orderProduct.pack }}</td>
          <td>{{ orderProduct.firstArticle }}</td>
          <td>{{ orderProduct.price }}</td>
          <td>{{ orderProduct.count }}</td>
          <td>{{ orderProduct.summa }}</td>
        </ng-container>
      </tr>
      </tbody>
    </table>
    <span class="result-sum">
    Разом: {{ (orderPrint.summa < 0 ? orderPrint.summa * -1 : orderPrint.summa).toFixed(2) }}
      <ng-container *ngIf="pageType === 1">
      {{ orderPrint.currency_id == 3 ? "УЕ" : "UAH" }}
    </ng-container>
    <ng-container *ngIf="pageType === 2">
      {{ "UAH" }}
    </ng-container>
  </span>
  </div>

  <div class="footer-goods mobile-version" [class.start-print]="startPrint">
    <footer>
      <small>© 2010-{{ currentYear }}. Всі права захищені.</small>
    </footer>
  </div>
</div>

<app-modal-order-return
  [returnSelected]="returnSelected"
  [returnGoods]="returnGoods"
  [returns]="returns"
  (setPrintChange)="setPrintChange()"
/>

<div class="modals info-payment" [class.start-print]="startPrint" [class.modals-show]="isModalInfoShow">
  <a class="close-modal" (click)="closeModal()"></a>
  <h4 class="mb30">Інфо по післяплатах</h4>
  <div *ngIf="sum && nalojkiSum">
    <p>Сума незабраних наложек: {{ nalojkiSum.orders_sum }} UAH</p>
    <br><br>
    <p>Потенційний прибуток незабраних наложек: {{ nalojkiSum.orders_profit }} UAH</p>
    <br><br>
    <p>Кількість незабраних замовлень: {{ nalojkiSum.orders_count }}</p>
  </div>
</div>

<app-modal-track-status/>

<app-modal-ttn-status-show/>

<app-modal-change-delivery-date
  [orderId]="selectedOrder?.order_id"
  [deliveryDate]="selectedOrder?.changeDeliveryDate"
  [deliveryDatesHours]="selectedOrder?.changeDeliveryDatesHours"
  (deliveryDateUpdated)="onDeliveryDateUpdated()"
/>

<div class="dark-layer"
     [class.start-print]="startPrint"
     [class.modals-show]="isDarkBackground"
     (click)="closeModal()">
</div>
